module.exports = __webpack_public_path__ + "media/assets/images/logo_cesp-0508b3118952c73dbbce2de73046c53e.svg";